var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-full max-w-screen px-4" }, [
    _c(
      "div",
      { staticClass: "mt-8" },
      [
        _c("h2", { staticClass: "text-2xl font-bold mb-4 pt-8" }, [
          _vm._v("Base2 AI Dashboard")
        ]),
        _vm._v(" "),
        _c("AISearch")
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-8" },
      [_c("StatsRow", { attrs: { id: _vm.id } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid grid-cols-1 md:grid-cols-3 mt-8 gap-4" },
      [
        _c("ReccomendationCard"),
        _vm._v(" "),
        _c("UpdatesCard"),
        _vm._v(" "),
        _c("HealthCard")
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid grid-cols-1 md:grid-cols-3 gap-4 h-full mt-8" },
      [
        _c(
          "div",
          { staticClass: "md:col-span-2 flex flex-col h-full" },
          [_c("CostGraphCard", { staticClass: "h-full" })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "md:col-span-1 flex flex-col gap-4 h-full" },
          [
            _c("MonthlyOverviewCard", { staticClass: "flex-1" }),
            _vm._v(" "),
            _c("BackupCard", { staticClass: "flex-1", attrs: { id: _vm.id } })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid grid-cols-1 md:grid-cols-9 gap-4 h-[500px] mt-8" },
      [
        _c(
          "div",
          { staticClass: "md:col-span-3 flex flex-col h-full gap-4" },
          [
            _c("MonitoredCard", {
              staticClass: "h-full",
              attrs: { id: _vm.id }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "md:col-span-4 flex flex-col gap-4 h-full" },
          [
            _c("ComparisonCostDeployment", { staticClass: "h-full" }),
            _vm._v(" "),
            _vm.id && _vm.activeType
              ? _c("TestDeployments", {
                  staticClass: "h-full",
                  attrs: {
                    id: _vm.id,
                    entityId: _vm.id,
                    activeType: _vm.activeType,
                    showGraph: true
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "md:col-span-2 flex flex-col h-full" },
          [
            _c("FeaturesCard", {
              staticClass: "h-full",
              attrs: { id: _vm.id, activeType: _vm.activeType }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid grid-cols-1 md:grid-cols-7 gap-4 h-[500px] mt-8" },
      [
        _c(
          "div",
          { staticClass: "md:col-span-3 flex flex-col h-full" },
          [_c("AlertsCard", { staticClass: "h-full", attrs: { id: _vm.id } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "md:col-span-2 flex flex-col h-full gap-4" },
          [
            _c("SlackCard", {
              staticClass: "h-full",
              attrs: { id: _vm.id, summaryOnly: "" }
            }),
            _vm._v(" "),
            _c("ProActiveCard", { staticClass: "h-full" })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "md:col-span-2 flex flex-col h-full" },
          [
            _c("ZendeskSummaryCard", {
              staticClass: "h-full",
              attrs: { id: _vm.id || "", activeType: _vm.activeType || "" }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid grid-cols-1 mt-8 gap-4" },
      [_c("CombinedMetrics", { attrs: { id: _vm.id } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bb67df1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bb67df1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AIPage.vue
// module id = null
// module chunks = 